import { render, staticRenderFns } from "./LaboratoryTrackingInstrumentModalForm.vue?vue&type=template&id=bc54b332&scoped=true&"
import script from "./LaboratoryTrackingInstrumentModalForm.vue?vue&type=script&lang=js&"
export * from "./LaboratoryTrackingInstrumentModalForm.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryTrackingInstrumentModalForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LaboratoryTrackingInstrumentModalForm.vue?vue&type=style&index=1&id=bc54b332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc54b332",
  null
  
)

export default component.exports